import { combineReducers } from 'redux'
import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import { push } from 'react-router-redux'
import _ from 'lodash'

import api from 'core/api'

const getType = type => `@payments/stripe/${type}`

const savePaymentData = createAction(getType('SAVE_PAYMENT'))
const clearPaymentData = createAction(getType('CLEAR_PAYMENT'))

export const submitStripePaymentThunk = createActionThunk(
  getType('ADD'),
  api('/payments/stripe', { method: 'POST' })
)

export const submitStripePayment = props => dispatch =>
  dispatch(submitStripePaymentThunk(props))
    .then(res => {
      dispatch(clearPaymentData())
      dispatch(toastr.add({ type: 'success', message: res.json.status }))
      dispatch(push('/'))
    })
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details)) {
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
        throw res.error.error.details
      }
      if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error') {
        dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
        throw res.error.error.details
      }
    })

export const submit = ({ stripe, ...props }) => dispatch =>
  stripe
    .createSource()
    .then(({ error, source, ...rest }) => {
      if (error) throw error
      if (source.card.three_d_secure === 'required') {
        const payment = {
          ...props,
          amount: Math.round(props.amount * 100)
        }
        return stripe
          .createSource({
            type: 'three_d_secure',
            three_d_secure: {
              card: source.id
            },
            redirect: {
              return_url: window.location.href
            },
            ...payment
          })
          .then(({ error, source, ...rest }) => {
            if (error) throw error
            dispatch(savePaymentData(payment))
            window.location = source.redirect.url
          })
      }
      return dispatch(
        submitStripePayment({
          ...props,
          amount: Math.round(props.amount * 100),
          source: source.id
        })
      )
    })
    .catch(res => {
      dispatch(toastr.add({ type: 'error', message: res.message }))
      throw res.message
    })

const initialState = { loading: false, payment: {} }

const reducer = handleActions(
  {
    [submitStripePaymentThunk.START]: state => ({ ...state, loading: true }),
    [submitStripePaymentThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [submitStripePaymentThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [submitStripePaymentThunk.ENDED]: state => ({ ...state, loading: false }),
    [savePaymentData]: (state, { payload }) => ({ ...state, loading: true, payment: payload }),
    [clearPaymentData]: (state, { payload }) => initialState
  },
  initialState
)

export default combineReducers({
  index: reducer
})



// WEBPACK FOOTER //
// ./src/modules/payments/stripe/index.js